import { useEffect, useState } from "react";
import FormStepForm from "../FormStepForm";
import FormTemplateForm from "../FormTemplateForm";
import { useSelector } from "react-redux";

export default function FormBuilder() {
    const [steps, setSteps] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [editingStep, setEditingStep] = useState(null);
    const [editingTemplate, setEditingTemplate] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;
    const { token } = useSelector((state) => state.auth);

    // Charger steps et templates
    useEffect(() => {
        fetch(apiUrl + "/api/formSteps")
            .then((res) => res.json())
            .then(setSteps)
            .catch(console.error);

        fetch(apiUrl + "/api/formTemplates")
            .then((res) => res.json())
            .then(setTemplates)
            .catch(console.error);
    }, [apiUrl]);

    // Soumission d’un step
    const handleStepSubmit = async (step) => {
        try {
            let response;
            if (editingStep) {
                // Update
                response = await fetch(`${apiUrl}/api/formSteps/${editingStep.id}`, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
                    body: JSON.stringify(step),
                });
            } else {
                // Create
                response = await fetch(`${apiUrl}/api/formSteps`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
                    body: JSON.stringify(step),
                });
            }
            const savedStep = await response.json();

            setSteps((prev) => {
                if (editingStep) {
                    return prev.map((s) => (s.id === editingStep.id ? savedStep : s));
                }
                return [...prev, savedStep];
            });
            setEditingStep(null);
        } catch (err) {
            console.error("Erreur lors de la sauvegarde du step:", err);
        }
    };

    // Soumission d’un template
    const handleTemplateSubmit = async (template) => {
        try {
            let response;
            if (editingTemplate) {
                response = await fetch(`${apiUrl}/api/formTemplates/${editingTemplate.id}`, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
                    body: JSON.stringify(template),
                });
            } else {
                response = await fetch(`${apiUrl}/api/formTemplates`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
                    body: JSON.stringify(template),
                });
            }
            const savedTemplate = await response.json();

            setTemplates((prev) => {
                if (editingTemplate) {
                    return prev.map((t) => (t.id === editingTemplate.id ? savedTemplate : t));
                }
                return [...prev, savedTemplate];
            });
            setEditingTemplate(null);
        } catch (err) {
            console.error("Erreur lors de la sauvegarde du template:", err);
        }
    };

    return (
        <div style={{ maxWidth: "800px", margin: "140px auto" }}>
            <h2>Form Steps</h2>
            <FormStepForm onSubmit={handleStepSubmit} initialData={editingStep} />

            <ul>
                {steps.map((step) => (
                    <li
                        key={step.id}
                        style={{ marginBottom: "8px", display: "flex", justifyContent: "space-between" }}
                    >
                        <span>{step.title}</span>
                        <button onClick={() => setEditingStep(step)} style={{ cursor: "pointer" }}>
                            Modifier
                        </button>
                    </li>
                ))}
            </ul>

            <h2>Form Templates</h2>
            <FormTemplateForm steps={steps} onSubmit={handleTemplateSubmit} initialData={editingTemplate} />

            <ul>
                {templates.map((template) => (
                    <li
                        key={template.id}
                        style={{ marginBottom: "8px", display: "flex", justifyContent: "space-between" }}
                    >
                        <span>{template.title}</span>
                        <button onClick={() => setEditingTemplate(template)} style={{ cursor: "pointer" }}>
                            Modifier
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}
